export const extractStoredFileUrl = (value = "") => {
  if (typeof value !== "string") return "";
  if (!value) return "";
  if (!value.includes("$")) return value;
  const parts = value.split("$");
  return parts[parts.length - 1] || "";
};

export const extractStoredFileName = (value = "", fallback = "View file") => {
  if (typeof value !== "string") return fallback;
  if (!value) return fallback;
  if (!value.includes("$")) {
    const rawUrl = extractStoredFileUrl(value);
    const cleanUrl = decodeURIComponent(rawUrl.split("?")[0]);
    const fullName = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
    return fullName.replace(/^\d+-/, "") || fallback;
  }
  return value.split("$")[0] || fallback;
};

export const isTemporaryFileUrl = (value = "") =>
  typeof value === "string" && (value.startsWith("blob:") || value.startsWith("data:"));

export const resolveSecureFileUrl = async (fileValue, token, download = false) => {
  const rawUrl = extractStoredFileUrl(fileValue);
  if (!rawUrl) return "";

  if (isTemporaryFileUrl(rawUrl)) {
    return rawUrl;
  }

  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/requests/file-access?fileUrl=${encodeURIComponent(fileValue)}&download=${download}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to generate secure file URL");
  }

  const data = await response.json();
  return data.url;
};

export const openSecureFileUrl = async (fileValue, token, openInNewTab = true, download = false) => {
  const secureUrl = await resolveSecureFileUrl(fileValue, token, download);
  if (!secureUrl) return "";

  if (openInNewTab) {
    window.open(secureUrl, "_blank", "noopener,noreferrer");
  }

  return secureUrl;
};
